'use strict'

import _ from 'lodash'

// ページに対してコンテンツの高さが足りない時にmainエリアの高さを確保する
const mainAreaHeightFixed = (() => {
  let $window
  let $mainArea

  const calc = () => {
    return $window.height() - $('#js-headerArea').height() - $mainArea.height() - $('#js-footerArea').height()
  }

  return {
    init () {
      $window = $(window)
      $mainArea = $('#js-mainArea')
    },

    setHeight () {
      const difference = calc()
      if (difference > 0) {
        $mainArea.css('height', $mainArea.height() + difference)
      } else {
        $mainArea.css('height', '')
      }
    }
  }
})()

$(function () {
  const ieVersion = AndApp.Device.ieVersion()
  if (ieVersion === '11.0' || ieVersion === '10.0') {
    mainAreaHeightFixed.init()
    mainAreaHeightFixed.setHeight()

    $(window).on('resize', _.debounce(mainAreaHeightFixed.setHeight, 300))
    window.addEventListener('gamelist_updated', _.debounce(mainAreaHeightFixed.setHeight, 300))
  }
})
